// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'module';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.363 3.393 8.188.717c.52-.206 1.1-.206 1.621 0l6.825 2.676a1.323 1.323 0 0 1 .803 1.246v8.721a1.322 1.322 0 0 1-.8 1.247l-6.825 2.677c-.52.204-1.1.204-1.621 0l-6.825-2.677a1.322 1.322 0 0 1-.803-1.247V4.64a1.322 1.322 0 0 1 .8-1.247zM9 7.015.828 3.81M9 7.015l8.172-3.204M9 17.437V7.015'
  />
);

export const viewBox = '0 0 18 18';
